import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userId: null,
  idolId: null,
  idolUuid: null,
  token: null,
  avatarUrl: null,
  coverUrl: null,
  nickName: null,
  fullName: null,
  isOfficial: false
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: { 
    setUserId(state, action) {
      state.userId = action.payload; 
    },
    setIdolId(state, action) {
      state.idolId = action.payload; 
    },
    setIdolUuid(state, action) {
      state.idolUuid = action.payload; 
    },
    setUserToken(state, action) {
      state.token = action.payload;
    },
    setAvatarUrl(state, action) {
      state.avatarUrl = action.payload;
    },
    setCoverUrl(state, action) {
      state.coverUrl = action.payload;
    },
    setNickName(state, action) {
      state.nickName = action.payload;
    },
    setFullName(state, action) {
      state.fullName = action.payload;
    },
    setIsOfficial(state, action) {
      state.isOfficial = action.payload;
    },
    // 切換目前使用中的偶像，payload 為 /idol/get-idol-array 回傳的一筆偶像資料。
    // walletSlice 會監聽此 action 把餘額歸零，只能用於「換偶像」，不要拿來同步同一個偶像的資料
    setCurrentIdol(state, action) {
      const idol = action.payload;
      state.idolId = idol.idol_id;
      state.idolUuid = idol.idol_uuid;
      state.nickName = idol.idol_nick_name;
      state.fullName = idol.idol_full_name;
      state.avatarUrl = idol.idol_avatar_url;
      state.coverUrl = idol.idol_cover_url;
      state.isOfficial = idol.idol_is_official;
    },
    // 清空整份登入狀態（登出、帳號停權、登入驗證過期 SYSTEM_1004、後台重導 AuthRedirect 共用）；idol、wallet、online、chat、notification 各 slice 會監聽此 action 一併清空
    clearSession() {
      return initialState;
    }
  }
})

export const {
  setUserId,
  setIdolId,
  setIdolUuid,
  setUserToken,
  setNickName,
  setFullName,
  setAvatarUrl,
  setCoverUrl,
  setIsOfficial,
  setCurrentIdol,
  clearSession
} = userSlice.actions;
export default userSlice.reducer;
